const initialState = {
  payslips: [],
  linkableEmployees: [],
  loading: false,
  actionLoading: false,
  error: null
};

const HrmsPayslipReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Payslips
    case 'FETCH_HRMS_PAYSLIPS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_HRMS_PAYSLIPS_SUCCESS':
      return { ...state, loading: false, payslips: action.payload, error: null };
    case 'FETCH_HRMS_PAYSLIPS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Linkable employees (for dropdowns)
    case 'FETCH_HRMS_EMPLOYEES_SUCCESS':
      return { ...state, linkableEmployees: action.payload };

    // Generate Payslip
    case 'GENERATE_HRMS_PAYSLIP_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GENERATE_HRMS_PAYSLIP_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        payslips: Array.isArray(action.payload)
          ? [...action.payload, ...state.payslips]
          : action.payload
          ? [action.payload, ...state.payslips]
          : state.payslips,
        error: null
      };
    case 'GENERATE_HRMS_PAYSLIP_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Mark Paid
    case 'MARK_HRMS_PAYSLIP_PAID_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'MARK_HRMS_PAYSLIP_PAID_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        // HRMS mark-paid response me full record nahi aata (sirf id
        // guaranteed hai) — isliye matched row ko merge karo, poora
        // replace mat karo, aur status ko khud PAID force set karo taake
        // button turant disable ho jaye (refetch se pehle hi).
        payslips: state.payslips.map((p) =>
          p.id === action.payload?.id ? { ...p, ...action.payload, status: 'PAID' } : p
        ),
        error: null
      };
    case 'MARK_HRMS_PAYSLIP_PAID_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Pay Payslip (payment popup — cash/bank/cheque, actually moves money)
    case 'PAY_HRMS_PAYSLIP_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'PAY_HRMS_PAYSLIP_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default HrmsPayslipReducer;